import { render, staticRenderFns } from "./ZahnwerkstattDentistsPage.vue?vue&type=template&id=383fbb7b"
import script from "./ZahnwerkstattDentistsPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattDentistsPage.vue?vue&type=script&lang=js"
import style0 from "./ZahnwerkstattDentistsPage.vue?vue&type=style&index=0&id=383fbb7b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports